/* eslint-disable camelcase */
import type { CamelCasedPropertiesDeep } from 'type-fest';

export enum OrderStatus {
  PROCESSING = 'processing',
  SUCCESSFUL = 'successful',
  FAILED = 'failed',
}

export interface OrderStatusResponseDTO {
  order_id: string;
  last_updated: string;
  status: OrderStatus;
}

export type OrderStatusResponse = CamelCasedPropertiesDeep<OrderStatusResponseDTO>;
